import React from 'react'
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import tw from "twin.macro";
import "../style.css"
import { css } from "styled-components/macro"; //eslint-disable-line
 let uni = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1CPRTl3YOvEZq9hvjQlRIRuqBO1cdo7XXPw&s'
function MARMARA() {
    const Subheading = tw.span`tracking-wider text-sm font-medium`;
    const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
    const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
    const Description = tw.span`inline-block mt-8`;
    const imageCss = tw`rounded-4xl`;
    const Container = tw.div`relative`;
    const TwoColumn = tw.div`flex flex-col lg:flex-row md:items-center max-w-screen-xl mx-auto py-20 md:py-24`;
    const Heading = tw.h1`font-black text-black text-3xl md:text-5xl  max-w-3xl`;


  return (
    <AnimationRevealPage>
         <Hero
        heading={<><HighlightedText>Marmara University</HighlightedText></>}
        description="Established in 1883 as Hamidiye Ticaret Mekteb-i Âlisi, Marmara University is one of Turkey’s leading higher education institutions. It has a diverse range of faculties, excelling in business, economics, and engineering programs"
        imageSrc={uni}
        imageCss={imageCss}
        imageDecoratorBlob={true}
    
      />
   <Container>
      <TwoColumn>
<Heading>Students</Heading>
</TwoColumn>
</Container>
      <Container>
      <TwoColumn>
      <div className="table-container">
    <table>
        <thead>
            <tr>
                <th>Name</th>
                <th>Department</th>
                <th>University Entrance Year</th>
                <th>FIRST Team Number - Name</th>
                <th>FIRST Programs Participated</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>İbrahim Emin Lüleci</td>
                <td>Mechanical Engineering</td>
                <td>2022</td>
                <td>8149 </td>
                <td>FRC</td>
            </tr>
            <tr>
                <td>Sipan Merhas Akcan</td>
                <td>_____________</td>
                <td>2024</td>
                <td>10213 </td>
                <td>FRC</td>
            </tr>
            <tr>
                <td>Ege Özkan</td>
                <td>Mechanical Engineer</td>
                <td>2024</td>
                <td>8054</td>
                <td>FRC</td>
            </tr>
        </tbody>
    </table>
</div>
</TwoColumn>
</Container>
<Footer />
        </ AnimationRevealPage>
  )
}

export default MARMARA